import * as React from 'react'
import {
  BookingStatsDetails,
  ReservationStatsTableCells,
  StatsCellContent,
  StatsTableOptions,
} from '@modules/reservations/models'
import { ReservationStatsTableExpandedRow } from '@modules/reservations/statistics/booking-stats/stats-details/stats-details-table/reservation-stats-table-expanded-row'
import { ReservationStatsReportCell } from '@modules/reservations/statistics/booking-stats/stats-details/stats-details-table/reservation-stats-report-cell'
import { useAppData } from '@components/hooks/use-app-data'
import { useStatsReportGenerator } from '@modules/reservations/statistics/booking-stats/stats-details/stats-details-table/use-stats-report-generator'

interface ReservationStatsOccupancyRowsProps {
  getCells: (element: string, options?: StatsTableOptions<BookingStatsDetails>) => ReservationStatsTableCells
}

export const ReservationStatsOccupancyRows: React.FC<ReservationStatsOccupancyRowsProps> = ({ getCells }) => {
  const { urls } = useAppData()
  const { generateReport } = useStatsReportGenerator()

  const handleReportGenerateClick = async (content: StatsCellContent<BookingStatsDetails>) => {
    await generateReport(content, urls.reports.report_task_apartment_occupancy_stats_report)
  }

  const getColoredCells = (element: string) => {
    const greenCells = [
      'occupied_houses',
      'blocked_houses',
      'occupied_apartments_40',
      'blocked_apartments_40',
      'occupied_apartments_55',
      'blocked_apartments_55',
      'object_occupancy',
    ]

    const className = greenCells.includes(element) ? 'text-danger' : 'text-success'
    return getCells(element, {
      tableCellOption: {
        wrapper: content => (
          <ReservationStatsReportCell
            content={content}
            onClick={() => handleReportGenerateClick(content)}
            color={className}
          />
        ),
      },

      tableRowSummaryOption: { className },
    })
  }

  const gerPercentageCells = el =>
    getCells(el, {
      tableCellOption: { unit: '%' },
      tableRowSummaryOption: { unit: '%' },
    })

  return (
    <>
      <ReservationStatsTableExpandedRow title="Zajętych domków" cells={getColoredCells('occupied_houses')} />
      <ReservationStatsTableExpandedRow title="Wolnych domków" cells={getColoredCells('free_houses')} />
      <ReservationStatsTableExpandedRow title="Zablokowanych domków" cells={getColoredCells('blocked_houses')} />
      <ReservationStatsTableExpandedRow
        title="Zajętych apartamentów 40m²"
        cells={getColoredCells('occupied_apartments_40')}
      />
      <ReservationStatsTableExpandedRow
        title="Wolnych apartamentów 40m²"
        cells={getColoredCells('free_apartments_40')}
      />
      <ReservationStatsTableExpandedRow
        title="Zablokowanych apartamentów 40m²"
        cells={getColoredCells('blocked_apartments_40')}
      />
      <ReservationStatsTableExpandedRow
        title="Zajętych apartamentów 55m²"
        cells={getColoredCells('occupied_apartments_55')}
      />
      <ReservationStatsTableExpandedRow
        title="Wolnych apartamentów 55m²"
        cells={getColoredCells('free_apartments_55')}
      />
      <ReservationStatsTableExpandedRow
        title="Zablokowanych apartamentów 55m²"
        cells={getColoredCells('blocked_apartments_55')}
      />
      <ReservationStatsTableExpandedRow title="Obłożenie obiektu" cells={gerPercentageCells('object_occupancy')} />
    </>
  )
}
